import styled from 'styled-components';
import ReactMarkdown from 'react-markdown';

export default function IntroMarkdown(props) {
  const { text, color, fontFamily, fontSize } = props;

  if (!text) return null;

  return (
    <MarkdownWrapper
      $color={color}
      $fontFamily={fontFamily || 'NotoSansKR-Medium'}
      $fontSize={fontSize || 16}>
      <ReactMarkdown>{text}</ReactMarkdown>
    </MarkdownWrapper>
  );
}

const MarkdownWrapper = styled.div`
  font-family: ${props => props.$fontFamily};
  font-size: ${props => props.$fontSize}px;

  color: ${props => props.$color};

  margin: 0;
  padding: 0 4px;

  line-height: 1.6;

  p { margin: 4px 0; }
  p:first-child { margin-top: 0; }
  p:last-child { margin-bottom: 0; }
  strong { font-family: NotoSansKR-Bold; }
  em { font-style: italic; }
  ul, ol { margin: 4px 0; padding-left: 20px; }
  li { margin: 2px 0; }
  code { font-family: monospace; }
`;
